// extracted by mini-css-extract-plugin
module.exports = {"captionDivider":"Q8eIEyO"};